import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { Buffer } from 'buffer';
import { initializeThemePreference } from './app/shared/services/theme.service';
(window as any).Buffer = Buffer;

const params = new URLSearchParams(window.location.search);
const token = params.get('accessToken');
if (token) {
  localStorage.setItem('accessToken', token);
 
  // Optionally clean the URL before Angular loads
  const cleanUrl = window.location.origin + window.location.pathname;
  window.history.replaceState({}, document.title, cleanUrl);
}

initializeThemePreference();

// Leaflet fix
// import * as L from 'leaflet';
// import 'leaflet/dist/images/marker-shadow.png';
// import 'leaflet/dist/images/marker-icon.png';
// import 'leaflet/dist/images/marker-icon-2x.png';

// (L.Icon.Default as any).mergeOptions({
//   iconRetinaUrl: 'assets/leaflet/marker-icon-2x.png',
//   iconUrl: 'assets/leaflet/marker-icon.png',
//   shadowUrl: 'assets/leaflet/marker-shadow.png',
// });

bootstrapApplication(AppComponent, appConfig);
